module.exports = __webpack_public_path__ + "img/MFT白皮书_25.481fc39f.jpg";